export const hasPermission = (permission: string): boolean => {
    const userSettings = JSON.parse(localStorage.getItem("user_settings") || "[]");
    return userSettings.some(
        (setting: any) =>
            setting.config_type === "Permissions" &&
            setting.config_value?.permissions?.includes(permission)
    );
};